module.exports = __webpack_public_path__ + "mg.svg?56421257c8ef399e5da94247d928097b";